import { TransportationTypeRecord } from '~/modules/transportation/types';
import { createQueryHook } from '~/shared/providers/api';

export const useTransportationTypesQuery = createQueryHook(
  'transportation.transportationTypes',
  (params: {
    ids?: string[];
    searchTerm?: string;
    limit?: number;
    offset?: number;
  }) => ({
    transportationTypes: {
      __args: {
        filter: {
          ids: params.ids,
          searchTerm: params.searchTerm,
        },
        pagination: {
          limit: params.limit ?? 10,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        name: true,
        description: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (
      data,
    ): { transportationTypes: TransportationTypeRecord[]; total?: number } => ({
      transportationTypes: data?.transportationTypes.entries.map((it) => ({
        id: it.id,
        name: it.name,
        description: it.description,
        timestamps: it.timestamps,
      })),
      total: data?.transportationTypes.page.total ?? undefined,
    }),
  },
);
